import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModelGroup} from '../model-group.model';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {DWPValidatorsService} from '../../dwpvalidators.service';
import isNumber from 'is-number';
import {Brand} from '../../brand/brand.model';
import {BrandService} from '../../brand/brand.service';
import {ModelGroupService} from '../model-group.service';
import {SweetUtil} from '../../components/commons/sweet/sweet-util-service';
import {I18nPipe} from '../../services/i18n.pipe';

@Component({
  selector: 'app-model-group-item',
  templateUrl: './model-group-item.component.html',
  styleUrls: ['./model-group-item.component.css']
})
export class ModelGroupItemComponent implements OnInit {

  @Input()
  brands: Array<Brand>;
  @Input()
  modelGroup: ModelGroup;
  newModelGroup = false;
  form: UntypedFormGroup;
  @Output()
  atModelGroup: EventEmitter<ModelGroup> = new EventEmitter<ModelGroup>();

  constructor(private validator: DWPValidatorsService, private formBuilder: UntypedFormBuilder, private brandService: BrandService,
              private service: ModelGroupService, private sweetUtil: SweetUtil, private i18N: I18nPipe) {
  }

  ngOnInit(): void {
    this.newModelGroup = !(this.modelGroup && isNumber(this.modelGroup.id));

    if (this.modelGroup) {
      this.form = this.formBuilder.group({
        make: new UntypedFormControl(this.modelGroup.make, {validators: [Validators.required]}),
        code: new UntypedFormControl(this.modelGroup.code, {validators: [this.validator.notBlank]}),
        description: new UntypedFormControl(this.modelGroup.description, {validators: [this.validator.notBlank]}),
      });
    }
  }

  brandsEqual(first: Brand, other: Brand): boolean {
    return first && other && first.name === other.name;

  }

  emit(): void {
    this.atModelGroup.emit(this.modelGroup);
  }

  save(): void {

    const saveModelGroup: ModelGroup = {
      id: this.modelGroup.id,
      code: this.form.get('code').value,
      description: this.form.get('description').value,
      make: this.form.get('make').value,
      startDate: this.modelGroup.startDate,
      createdOn: this.modelGroup.createdOn
    };

    this.service.save(saveModelGroup).subscribe(async (saved: ModelGroup) => {
      await this.sweetUtil.showInfoTranslated('successfully-saved');
    }, async () => {
      await this.sweetUtil.showError('saving-failed');
    });
  }

  saveOrUpdateButtonText(): string {
    return this.newModelGroup ? this.i18N.transform('', 'save') : this.i18N.transform('', 'update');
  }

}
